import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import { Validator } from 'vee-validate'

export default {
  name: 'AWBVerificationDimWt',
  components: {
    VueElementLoading
  },
  props: [],
  data() {
    return {
      AWBnumber:'',
      addmodalShow: false,
      isLoadingSearch:false,
      totalDimRows: 0,
      inputs: {},
      remArr: [],
      CFTValue: 0,
      ppw : '',
      pvw : '',
      awbvst : '',
      vpw : '',
      vvw : '',
      awbvdby : '',
      pwd : '',
      vwd : '',
      awbvdat : '',
      awbvdt : '',
      totbx : 0,
      totRc : 0,
      hubid : '',
      isverificationenabled:true,
      isverificationenabledMsg:'',
      confmsg:'',
      isdisable:true,
      destinationhubId:''
    }
  },
  computed: {

  },
  filters: {

  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes             = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext         = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail        = JSON.parse(plaintext);
    this.useremail        = userdetail[0].email;
    this.hubid            = userdetail[0].HubId[0];

    this.AWBnumber        = this.$route.query.AWBNo ? this.$route.query.AWBNo : '';
    this.destinationhubId = this.$route.query.destinationhubId ? this.$route.query.destinationhubId : '';
    this.$refs.AWBnumber.focus();

    this.checkVerificationPalletizationEnabled();
    this.getHubName(userdetail[0].HubId);
  },
  methods: {
    getHubName(hubid) {
      this.input = {
        hubids: hubid
      }
      axios({
          method: 'POST',
          url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.awbvdat = result.data.ResponseData[0].HubName + " (" + result.data.ResponseData[0].HubID + ") "
          }
        }, error => {
          console.error(error)
        })
    },

    getAWBVerificationDimWt(){
      if(!this.AWBnumber.trim()) return false;

      this.isLoadingSearch = true;
      this.inputs   = {};
      this.remArr   = [];

      axios({
        method: 'GET',
        'url': apiUrl.api_url_hubops + "getParentDetailsforAWBVerification?ParentAWB="+this.AWBnumber + '&currentHubId=' + this.hubid,
        headers: {
          'Authorization': "authkey xB84JJ89Hd25"
        }
      })
      .then(result => {
        if (result.data.ResultCode == 100) {
          this.inputs   = result.data.parentAWBDetailsResponseData;

          this.CFTValue = result.data.CFTValue;
          this.awbvdby  = this.inputs.MeasurementDoneBy ? this.inputs.MeasurementDoneBy : '';
          this.awbvdt   = this.inputs.MeasurementTime ? this.inputs.MeasurementTime : '';
          this.awbvdat  = this.inputs.MeasurementLocationName ? this.inputs.MeasurementLocationName : '';
          this.awbvst  = this.inputs.IsMeasurementFlag ? 'Completed' : 'Pending';

          this.totRc    = this.inputs.SKUDetails.length;
          this.totbx    = this.inputs.MPSCount;
          this.ppw      = (Math.floor(parseFloat(this.inputs.TotalPickupPhysicalWeight) * 1000) / 1000).toFixed(3);
          this.vpw      = (this.inputs.TotalVerifiedPhysicalWeight > 0) ? (Math.floor(parseFloat(this.inputs.TotalVerifiedPhysicalWeight) * 1000) / 1000).toFixed(3) : '';
          this.pwd      = (Math.floor(parseFloat(parseFloat(this.inputs.TotalVerifiedPhysicalWeight) - parseFloat(this.inputs.TotalPickupPhysicalWeight)) * 1000) / 1000).toFixed(3);
          this.pvw      = (Math.floor(parseFloat(this.inputs.TotalPickupVolumetricWeight) * 1000) / 1000).toFixed(3);
          this.vvw      = (this.inputs.TotalVerifiedVolumetricWeight > 0) ? (Math.floor(parseFloat(this.inputs.TotalVerifiedVolumetricWeight) * 1000) / 1000).toFixed(3) : '';
          this.vwd      = (Math.floor(parseFloat(parseFloat(this.inputs.TotalVerifiedVolumetricWeight) - parseFloat(this.inputs.TotalPickupVolumetricWeight)) * 1000) / 1000).toFixed(3);

          for (var i = 0; i < this.inputs.SKUDetails.length; i++) {
            //this.inputs.SKUDetails[i].PackageDetails.Weight.PhyWeight = (Math.floor(parseFloat(parseFloat(this.inputs.SKUDetails[i].PackageDetails.Weight.PhyWeight) / parseFloat(this.inputs.SKUDetails[i].NoOfBoxes)) * 1000) / 1000).toFixed(3);
            this.inputs.SKUDetails[i].totPWeight = (Math.floor(parseFloat(this.inputs.SKUDetails[i].BoxTotalPhysicalWeight) * 1000) / 1000).toFixed(3);
            //this.inputs.SKUDetails[i].PackageDetails.Weight.VolWeight = (Math.floor(parseFloat((parseFloat(this.inputs.SKUDetails[i].BoxDimensions) / parseFloat(this.CFTValue)) * parseFloat(this.inputs.SKUDetails[i].NoOfBoxes)) * 1000) / 1000).toFixed(3);
            this.inputs.SKUDetails[i].totVWeight = (Math.floor(parseFloat(this.inputs.SKUDetails[i].BoxTotalVolumetricWeight) * 1000) / 1000).toFixed(3);
          }

          this.isdisable = false;
        }else{
          this.$alert(result.data.ReturnMessage, "", "error");
        }
        this.isLoadingSearch = false;
      }, error => {
        this.isLoadingSearch = false; console.error(error);
      })
    },

    onSubmit: function() {
      this.$validator.validateAll()
        .then((result) => {
          this.confmsg = 'Do you want to verify AWB number dimensions & weight.';
          if (!result) {
            console.log('errors exist'); return false;
          }else{
            let noOfBox = this.inputs.SKUDetails.reduce(function(sum, current) { return parseInt(parseInt(sum) + parseInt(current.NoOfBoxes)); }, 0);
            if(noOfBox == this.inputs.MPSCount){

              if(this.ppw != this.vpw)
                this.confmsg = 'There is a difference between Verified physical weight and Picked physical weight. Click confirm to save the Verified physical weight.';
              else if(this.pvw != this.vvw)
                this.confmsg = 'There is a difference between Verified volumetric weight and Picked volumetric weight. Click confirm to save the Verified volumetric weight.';
              else if(noOfBox < this.inputs.MPSCount)
                this.confmsg = 'The number of Box Types picked is different from the Number of Box Types verified. Please check and confirm.';

              this.addmodalShow = true;
            }else{
              this.$alert("Number of boxes mismatch between header and line", "", "error");
            }
          }
        }).catch(() => {});
    },

    addBox () {
      if(!this.AWBnumber.trim()) return false;

      if(this.inputs.SKUDetails){
        this.inputs.SKUDetails.push({
          "HSN": null,
          "SKU": "Other",
          "BoxType": "Other",
          "SKUType": this.inputs.SKUDetails.length+1,
          "NoOfBoxes": "",
          "SKUAction": "Add",
          "NoOfInscan": null,
          "OtherBoxType": 1,
          "BoxDimensions": "",
          "PackageDetails": {
            "Weight": {
              "Unit": "Kg",
              "PhyWeight": "",
              "VolWeight": "",
              "BillableWeight": ""
            },
            "Dimensions": {
              "Unit": "cm",
              "Width": "",
              "Height": "",
              "Length": ""
            }
          },
          "ChildNoOfInscan": null,
          "UniqueReferenceNumber": null
        })
      }
    },

    removeBoxes (){
      if(this.remArr.length>0){
        let rArr = new Set(this.remArr);

        this.inputs.SKUDetails = this.inputs.SKUDetails.filter((val, i) => !rArr.has(i));

        this.vpw = (Math.floor(this.inputs.SKUDetails.reduce(function(sum, current) { return parseFloat(parseFloat(sum) + parseFloat(current.totPWeight)); }, 0) * 1000) / 1000).toFixed(3);
        this.pwd = (Math.floor(parseFloat(parseFloat(this.vpw) - parseFloat(this.ppw)) * 1000) / 1000).toFixed(3);
        this.vvw = (Math.floor(this.inputs.SKUDetails.reduce(function(sum, current) { return parseFloat(parseFloat(sum) + parseFloat(current.totVWeight)); }, 0) * 1000) / 1000).toFixed(3);
        this.vwd = (Math.floor(parseFloat(parseFloat(this.vvw) - parseFloat(this.pvw)) * 1000) / 1000).toFixed(3);

        this.remArr = [];
      }
    },

    closeStatusModal() {
      this.addmodalShow = false
    },

    //function is used for calculate weight
    boxCalc(i){
      this.isdisable = true;
      if((this.inputs.SKUDetails[i].PackageDetails.Dimensions.Length && this.inputs.SKUDetails[i].PackageDetails.Dimensions.Length <= 0) ||
      (this.inputs.SKUDetails[i].PackageDetails.Dimensions.Width && this.inputs.SKUDetails[i].PackageDetails.Dimensions.Width <= 0) ||
      (this.inputs.SKUDetails[i].PackageDetails.Dimensions.Height && this.inputs.SKUDetails[i].PackageDetails.Dimensions.Height <= 0) ||
      (this.inputs.SKUDetails[i].NoOfBoxes && this.inputs.SKUDetails[i].NoOfBoxes <= 0)){
        this.inputs.SKUDetails[i].PackageDetails.Dimensions.Length = this.inputs.SKUDetails[i].PackageDetails.Dimensions.Length > 0 ? this.inputs.SKUDetails[i].PackageDetails.Dimensions.Length : '';
        this.inputs.SKUDetails[i].PackageDetails.Dimensions.Width = this.inputs.SKUDetails[i].PackageDetails.Dimensions.Width > 0 ? this.inputs.SKUDetails[i].PackageDetails.Dimensions.Width : '';
        this.inputs.SKUDetails[i].PackageDetails.Dimensions.Height = this.inputs.SKUDetails[i].PackageDetails.Dimensions.Height > 0 ? this.inputs.SKUDetails[i].PackageDetails.Dimensions.Height : '';
        this.inputs.SKUDetails[i].NoOfBoxes = this.inputs.SKUDetails[i].NoOfBoxes > 0 ? this.inputs.SKUDetails[i].NoOfBoxes : '';

        this.$alertify.error("Input value should be greater than 0!"); return false;
      }
      else if(this.inputs.SKUDetails[i].PackageDetails.Dimensions.Length <= 0 ||
        this.inputs.SKUDetails[i].PackageDetails.Dimensions.Width <= 0 ||
        this.inputs.SKUDetails[i].PackageDetails.Dimensions.Height <= 0 ||
        this.inputs.SKUDetails[i].PackageDetails.Dimensions.NoOfBoxes <= 0){
        return false;
      }

      if(this.inputs.SKUDetails[i].NoOfBoxes){

        this.inputs.SKUDetails[i].PackageDetails.Weight.VolWeight = ((Math.floor(parseFloat(((parseFloat(this.inputs.SKUDetails[i].PackageDetails.Dimensions.Length) * parseFloat(this.inputs.SKUDetails[i].PackageDetails.Dimensions.Width) * parseFloat(this.inputs.SKUDetails[i].PackageDetails.Dimensions.Height)) / parseFloat(27000)) * parseFloat(this.CFTValue)) * 1000) / 1000).toFixed(3)).toString();

        let currBox = this.inputs.SKUDetails[i].NoOfBoxes;
        // let currSKUWgt = this.inputs.SKUDetails[i].PackageDetails.Weight.PhyWeight;
        // let currSKUVwgt = this.inputs.SKUDetails[i].PackageDetails.Weight.VolWeight;

        let rArr = new Set([i]);
        let nArr = this.inputs.SKUDetails.filter((val, j) => !rArr.has(j));

        //this.inputs.SKUDetails[i].PackageDetails.Weight.PhyWeight = ((Math.floor(parseFloat(parseFloat(this.inputs.TotalPickupPhysicalWeight ? this.inputs.TotalPickupPhysicalWeight : 0) / parseFloat(this.inputs.SKUDetails[i].NoOfBoxes)) * 1000) / 1000).toFixed(3)).toString();
        if(this.inputs.SKUDetails[i].PackageDetails.Weight.PhyWeight && this.inputs.SKUDetails[i].PackageDetails.Weight.PhyWeight > 0){

          var result = nArr.find(obj => {
            return (
              (Math.floor(parseFloat(obj.PackageDetails.Dimensions.Length) * 100) / 100).toFixed(2) === (Math.floor(parseFloat(this.inputs.SKUDetails[i].PackageDetails.Dimensions.Length) * 100) / 100).toFixed(2) &&
              (Math.floor(parseFloat(obj.PackageDetails.Dimensions.Width) * 100) / 100).toFixed(2) === (Math.floor(parseFloat(this.inputs.SKUDetails[i].PackageDetails.Dimensions.Width) * 100) / 100).toFixed(2) &&
              (Math.floor(parseFloat(obj.PackageDetails.Dimensions.Height) * 100) / 100).toFixed(2) === (Math.floor(parseFloat(this.inputs.SKUDetails[i].PackageDetails.Dimensions.Height) * 100) / 100).toFixed(2) &&
              (Math.floor(parseFloat(obj.PackageDetails.Weight.PhyWeight) * 1000) / 1000).toFixed(3) === (Math.floor(parseFloat(this.inputs.SKUDetails[i].PackageDetails.Weight.PhyWeight) * 1000) / 1000).toFixed(3)
            )
          })

          if(result && result.UniqueReferenceNumber == null){

            this.$alert("One or more boxes with the same dimensions are already available, so the number of the new box will be added to the old box", "", "error");

            this.inputs.SKUDetails = this.inputs.SKUDetails.filter((val, j) => !rArr.has(j));

            let index = this.inputs.SKUDetails.findIndex(function(item, k){
              return item.SKUType === result.SKUType
            });

            if(index >= 0){

              i = index;
              this.inputs.SKUDetails[i].NoOfBoxes = parseInt(parseInt(this.inputs.SKUDetails[i].NoOfBoxes) + parseInt(currBox));
              // this.inputs.SKUDetails[i].PackageDetails.Weight.PhyWeight = (Math.floor(parseFloat(parseFloat(this.inputs.SKUDetails[i].PackageDetails.Weight.PhyWeight) + parseFloat(currSKUWgt)) * 1000) / 1000).toFixed(3);
              // this.inputs.SKUDetails[i].PackageDetails.Weight.VolWeight = (Math.floor(parseFloat(parseFloat(this.inputs.SKUDetails[i].PackageDetails.Weight.VolWeight) + parseFloat(currSKUVwgt)) * 1000) / 1000).toFixed(3);
            }
          }else if(result && result.UniqueReferenceNumber){
            this.$alert("One or more boxes with the same dimensions are already available, and new boxes with the same dimensions will not be accepted", "", "error"); return false;
          }

          this.inputs.SKUDetails[i].totPWeight = (Math.floor(parseFloat(parseFloat(this.inputs.SKUDetails[i].PackageDetails.Weight.PhyWeight) * parseFloat(this.inputs.SKUDetails[i].NoOfBoxes)) * 1000) / 1000).toFixed(3);
          this.inputs.SKUDetails[i].PackageDetails.Weight.BillableWeight = (Math.max(this.inputs.SKUDetails[i].PackageDetails.Weight.PhyWeight,this.inputs.SKUDetails[i].PackageDetails.Weight.VolWeight)).toString();
          this.vpw = (Math.floor(this.inputs.SKUDetails.reduce(function(sum, current) { return parseFloat(parseFloat(sum) + parseFloat(current.totPWeight)); }, 0) * 1000) / 1000).toFixed(3);
          this.pwd = (Math.floor(parseFloat(parseFloat(this.vpw) - parseFloat(this.ppw)) * 1000) / 1000).toFixed(3);

          this.isdisable = false;
        }

        this.inputs.SKUDetails[i].totVWeight = (Math.floor(parseFloat(parseFloat(this.inputs.SKUDetails[i].NoOfBoxes) * parseFloat(this.inputs.SKUDetails[i].PackageDetails.Weight.VolWeight)) * 1000) / 1000).toFixed(3);
        this.vvw = (Math.floor(this.inputs.SKUDetails.reduce(function(sum, current) { return parseFloat(parseFloat(sum) + parseFloat(current.totVWeight)); }, 0) * 1000) / 1000).toFixed(3);
        this.vwd = (Math.floor(parseFloat(parseFloat(this.vvw) - parseFloat(this.pvw)) * 1000) / 1000).toFixed(3);
      }
    },

    phyCalc(i){
     this.isdisable = true;
     this.inputs.SKUDetails[i].PackageDetails.Weight.PhyWeight = this.inputs.SKUDetails[i].PackageDetails.Weight.PhyWeight > 0 ? this.inputs.SKUDetails[i].PackageDetails.Weight.PhyWeight : '';


     if(this.inputs.SKUDetails[i].PackageDetails.Dimensions.Length <= 0 ||
       this.inputs.SKUDetails[i].PackageDetails.Dimensions.Width <= 0 ||
       this.inputs.SKUDetails[i].PackageDetails.Dimensions.Height <= 0 ||
       this.inputs.SKUDetails[i].PackageDetails.Dimensions.NoOfBoxes <= 0 ||
       this.inputs.SKUDetails[i].PackageDetails.Weight.PhyWeight <= 0){
       this.$alertify.error("Input value should be greater than 0!")
       return false;
     }else
     if(this.inputs.SKUDetails[i].PackageDetails.Weight.PhyWeight <= 0){
       return false;
     }

     this.inputs.SKUDetails[i].PackageDetails.Weight.VolWeight = ((Math.floor(parseFloat(((parseFloat(this.inputs.SKUDetails[i].PackageDetails.Dimensions.Length) * parseFloat(this.inputs.SKUDetails[i].PackageDetails.Dimensions.Width) * parseFloat(this.inputs.SKUDetails[i].PackageDetails.Dimensions.Height)) / parseFloat(27000)) * parseFloat(this.CFTValue)) * 1000) / 1000).toFixed(3)).toString();

     let currBox = this.inputs.SKUDetails[i].NoOfBoxes;
     // let currSKUWgt = this.inputs.SKUDetails[i].PackageDetails.Weight.PhyWeight;
     // let currSKUVwgt = this.inputs.SKUDetails[i].PackageDetails.Weight.VolWeight;

     let rArr = new Set([i]);
     let nArr = this.inputs.SKUDetails.filter((val, j) => !rArr.has(j));

     var result = nArr.find(obj => {
       return (
         (Math.floor(parseFloat(obj.PackageDetails.Dimensions.Length) * 100) / 100).toFixed(2) === (Math.floor(parseFloat(this.inputs.SKUDetails[i].PackageDetails.Dimensions.Length) * 100) / 100).toFixed(2) &&
         (Math.floor(parseFloat(obj.PackageDetails.Dimensions.Width) * 100) / 100).toFixed(2) === (Math.floor(parseFloat(this.inputs.SKUDetails[i].PackageDetails.Dimensions.Width) * 100) / 100).toFixed(2) &&
         (Math.floor(parseFloat(obj.PackageDetails.Dimensions.Height) * 100) / 100).toFixed(2) === (Math.floor(parseFloat(this.inputs.SKUDetails[i].PackageDetails.Dimensions.Height) * 100) / 100).toFixed(2) &&
         (Math.floor(parseFloat(obj.PackageDetails.Weight.PhyWeight) * 1000) / 1000).toFixed(3) === (Math.floor(parseFloat(this.inputs.SKUDetails[i].PackageDetails.Weight.PhyWeight) * 1000) / 1000).toFixed(3)
       )
     })

     if(result && result.UniqueReferenceNumber == null){

       this.$alert("One or more boxes with the same dimensions are already available, so the number of the new box will be added to the old box", "", "error");

       this.inputs.SKUDetails = this.inputs.SKUDetails.filter((val, j) => !rArr.has(j));

       let index = this.inputs.SKUDetails.findIndex(function(item, k){
         return item.SKUType === result.SKUType
       });

       if(index >= 0){

         i = index;
         this.inputs.SKUDetails[i].NoOfBoxes = parseInt(parseInt(this.inputs.SKUDetails[i].NoOfBoxes) + parseInt(currBox));
         // this.inputs.SKUDetails[i].PackageDetails.Weight.PhyWeight = (Math.floor(parseFloat(parseFloat(this.inputs.SKUDetails[i].PackageDetails.Weight.PhyWeight) + parseFloat(currSKUWgt)) * 1000) / 1000).toFixed(3);
         // this.inputs.SKUDetails[i].PackageDetails.Weight.VolWeight = (Math.floor(parseFloat(parseFloat(this.inputs.SKUDetails[i].PackageDetails.Weight.VolWeight) + parseFloat(currSKUVwgt)) * 1000) / 1000).toFixed(3);
       }
     }else if(result && result.UniqueReferenceNumber){
       this.$alert("One or more boxes with the same dimensions are already available, and new boxes with the same dimensions will not be accepted", "", "error"); return false;
     }

     if(this.inputs.SKUDetails[i].NoOfBoxes){
       this.inputs.SKUDetails[i].totPWeight = (Math.floor(parseFloat(parseFloat(this.inputs.SKUDetails[i].PackageDetails.Weight.PhyWeight) * parseFloat(this.inputs.SKUDetails[i].NoOfBoxes)) * 1000) / 1000).toFixed(3);
       this.inputs.SKUDetails[i].totVWeight = (Math.floor(parseFloat(parseFloat(this.inputs.SKUDetails[i].NoOfBoxes) * parseFloat(this.inputs.SKUDetails[i].PackageDetails.Weight.VolWeight)) * 1000) / 1000).toFixed(3);
       this.inputs.SKUDetails[i].PackageDetails.Weight.BillableWeight = (Math.max(this.inputs.SKUDetails[i].PackageDetails.Weight.PhyWeight,this.inputs.SKUDetails[i].PackageDetails.Weight.VolWeight)).toString();
       this.vpw = (Math.floor(this.inputs.SKUDetails.reduce(function(sum, current) { return parseFloat(parseFloat(sum) + parseFloat(current.totPWeight)); }, 0) * 1000) / 1000).toFixed(3);
       this.pwd = (Math.floor(parseFloat(parseFloat(this.vpw) - parseFloat(this.ppw)) * 1000) / 1000).toFixed(3);

       this.isdisable = false;
     }
   },

    takeAction() {
     this.verifyAWB();
    },

    verifyAWB() {
      if(!this.AWBnumber.trim() || (this.vpw=='NaN' || this.vvw=='NaN')) return false;

      this.isLoadingSearch = true;

      this.input = ({
        parentAWB: this.AWBnumber,
        MpsCount: this.inputs.MPSCount,
        measurementmethod: "Manual",
        dimentionuom: "cm",
        measurementlocation: this.hubid,
        measurementdoneby: this.useremail,
        mpsstatus: "done",
        cft: this.CFTValue,
        SKUDetails: this.inputs.SKUDetails.map(j => ({
          HSN: j.HSN,
          SKU: "Other",
          BoxType: "Other",
          SKUType: j.SKUType,
          NoOfBoxes: j.NoOfBoxes,
          UpdatedNoOfBoxes: j.NoOfBoxes,
          SKUAction: j.SKUAction,
          NoOfInscan: j.NoOfInscan,
          OtherBoxType: j.OtherBoxType,
          BoxDimensions: (j.PackageDetails.Dimensions.Length+'*'+j.PackageDetails.Dimensions.Width+'*'+j.PackageDetails.Dimensions.Height),
          PackageDetails: j.PackageDetails,
          ChildNoOfInscan: j.ChildNoOfInscan,
          UniqueReferenceNumber: j.UniqueReferenceNumber
        })),
        totalVerifiedPhysicalWeight:this.vpw!=''?this.vpw:this.ppw,
        totalVerifiedVolumetricWeight:this.vvw!=''?this.vvw:this.pvw
      });

      axios({
        method: 'POST',
        'url': apiUrl.api_url_hubops + 'updateParentDetailsforAWBVerification',
        'data': this.input,
        headers: {
          'Authorization': "authkey xB84JJ89Hd25"
        }
      })
      .then(result => {
        if (result.data.ReturnCode == 100) {
          //this.$alert(result.data.ReturnMessage, "", "success");
          this.$alertify.success(result.data.ReturnMessage);
          this.getAWBVerificationDimWt();
        } else {
          this.$alert(result.data.ReturnMessage, "", "error");
        }
        this.isLoadingSearch = false;
      }, error => {
        this.isLoadingSearch = false;
        console.error(error)
      })
   },

    checkVerificationPalletizationEnabled() {

     this.isLoadingSearch = true;
     axios({
         method: 'GET',
         'url': apiUrl.api_url_hubops + 'checkVerificationPalletizationEnabled?hubId='+this.hubid+'&destinationhubId='+this.destinationhubId,
         headers: {
           'authorization': 'authkey xB84JJ89Hd25',
         }
       })
       .then(result => {
         this.isLoadingSearch = false;
         if (result.data.ResultCode == 100) {
           this.isverificationenabled = result.data.ResponseData[0].isverificationenabled;
           if(this.isverificationenabled == true){
            this.getAWBVerificationDimWt();
           }else{
            this.isverificationenabledMsg='For this Hub verification Hub is ' + result.data.verificationHubName + '.';
           }
         } else if (result.data.ResultCode == 107) {
           this.isverificationenabled = true;
           this.getAWBVerificationDimWt();
         } else {
           this.isverificationenabled = false;
           this.isverificationenabledMsg='The current Hub is not a controlling Hub for this AWB.';
         }
       }, error => {
         this.isverificationenabled = false; this.isLoadingSearch = false;
       })
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/AWBVerificationDimWt/AWBVerificationDimWt.component.js